<template>
  <div>
    <st_header_cop></st_header_cop>
    <div class="index_page contanic_no_lock">
      <div v-for="item in dataList" :key="item.id">
          <st_list_item_row_cop
            item_num="4"
            :id="item.id"
            :title_txt="item.title"
            :content_txt="item.sub_content"
            :image_url="item.cover_url">
          </st_list_item_row_cop>
      </div>
    </div>
    
    <div class="page_div">
      <el-pagination
        layout="prev, pager, next"
        :total="pagination.total"
        :page-size="pagination.size"
        :hide-on-single-page="true"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>

    <st_footer_cop :active-index="'2'"></st_footer_cop>
  </div>
</template>

<script>
import st_header from "../components/header_main.vue"
import st_footer from "../components/footer.vue"
import st_list_item_row from "../components/list_item_column.vue"
import { getContentPage } from '../utils/api'
export default {
  name:"project",
  components:{
    st_header_cop : st_header,
    st_footer_cop : st_footer,
    st_list_item_row_cop: st_list_item_row,
  },
  data() {
    return {
      dataList:[],    //单页数据
      pagination:{    //分页数据
        page:1,
        size:4,
        total:100
      }
    };
  },
  methods:{
    //请求网络数据
    getData(dataReq){
      let that = this;
      that.load.$emit('loading', true);
      getContentPage(dataReq)
      .then(function(res){
        if(res.code===1000){
          that.dataList = res.data.list //记录当前页数据
          that.pagination.page = res.data.pagination.page 
          that.pagination.size = res.data.pagination.size 
          that.pagination.total = res.data.pagination.total 
          console.log(that.pagination)
          setTimeout(function(){
            that.load.$emit('loading', false);
          },1000)
        }else{
          console.error("error")
        }
      }).catch(function(err){
        console.log(err)
      })
    },
    //点击分页再次请求
    handleCurrentChange(val) {
      this.getData({"content_type":"项目案例","page":val,"size":4});
    }
  },
  created(){
    //默认请求
    this.getData({"content_type":"项目案例","page":1,"size":4});
  }

}
</script>

<style scoped lang="scss">
.page_div{
  text-align: right;
  padding-right: 5%;
  margin-top: 20px;
}
.index_page{
  background: rgba(255,255,255,0);
  padding-left: 2%;
  padding-right: 2%;
}
.contanic{
  padding-top: 80px;
  height: 75vh;
}
.contanic_no_lock{
  padding-top: 80px;
  height: auto;
  min-height: 70vh;
}

</style>



// WEBPACK FOOTER //
// src/view/project.vue